import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=674f2026"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=674f2026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports